import { Fee } from '@macs-frontend/features/shared/models/fee.model';
import { BaseEntity } from './base-entity.model';

export interface FeeGroup extends BaseEntity {
  status: FeeGroupStatuses;
  name: string;
  fees: Fee[];
}

export enum FeeGroupStatuses {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
